import { UserType } from "@src/types.generated";
import React, { FC } from "react";
import UserTypeDescription from "@src/features/users/dialogs/inviteOrEditUserDialog/UserTypeDescription";
import SegmentedControl from "@src/lib/ui/SegmentedControl";

type Props = {
  userType: UserType;
  setUserType: (role: UserType) => void;
  disableTraineeOption?: boolean;
  showDescription: boolean;
};
const UserTypeSelection: FC<Props> = ({
  userType,
  setUserType,
  disableTraineeOption,
  showDescription,
}) => {
  let choices;
  if (disableTraineeOption) {
    choices = [
      {
        value: UserType.Manager,
        label: "Manager",
        dataTestId: "ManagerSelection",
      },
      { value: UserType.Admin, label: "Admin", dataTestId: "AdminSelection" },
    ];
  } else {
    choices = [
      {
        value: UserType.Employee,
        label: "Trainee",
        dataTestId: "TraineeSelection",
      },
      {
        value: UserType.Manager,
        label: "Manager",
        dataTestId: "ManagerSelection",
      },
      { value: UserType.Admin, label: "Admin", dataTestId: "AdminSelection" },
    ];
  }
  return (
    <div className="flex flex-1 flex-col self-stretch">
      <SegmentedControl
        aria-label="User type"
        fill
        value={userType}
        onValueChange={setUserType}
        options={choices}
      />
      {showDescription && <UserTypeDescription userType={userType} />}
    </div>
  );
};

export default UserTypeSelection;
